import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class GameSessionService extends RestfulService<Models.GameSession> {

  constructor(public restService: RestService) {
    super(Models.GameSession);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('game-sessions');
  }

}
